/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2020-12-10 08:38:48
 */

import Api from 'src/util/api';
import { PageDo, Result, ResultPageDo, Integer } from 'src/types/base';
import { defaultNullValue } from 'src/config';
export declare namespace DeviceControlDOI {
    export interface RowDataI {
        operating_name: string;
        operating_result: string;
        operation_time: number;
        operation_user: string;
        polid: string;
    }

    export interface QueryRowDataParamsI extends PageDo {
        mn?: string;
        start_time?: Integer;
        end_time?: Integer;
    }
    export interface NewestRecordI {
        cn: string
        operating_result: string
        operation_time: number
        operation_user: string
    }

    export interface QueryDetailResultI {}

    export interface OperateParamsI {}
}
export default class DeviceControlApi {
    /**
     * 查询列表
     * @param {ControlRecordDOI.QueryRowDataParamsI} params
     * @returns {Promise<ResultPageDo<PeopleManageRowI[]>>}
     */
    static async searchRecordList(params: DeviceControlDOI.QueryRowDataParamsI): Promise<ResultPageDo<DeviceControlDOI.RowDataI[]>> {
        return Api.post('/countercharge/record/operation', {
            start_time: defaultNullValue,
            end_time:defaultNullValue,
            ...params
        });
    }
    static async deviceControl(url: string, params: any): Promise<Result<any>> {
        return Api.post(url, params);
    }
    static async queryNewestRecord(params: { mn: string; cns: string[], polid: string}): Promise<Result<DeviceControlDOI.NewestRecordI[]>> {
        return Api.post('/countercharge/newest_operating_result/query', params);
    }
    
    /**
     * @param params 查询站点是否拥有蜂鸣器
     */
    static async buzzerAuthority(params: { mn: string}): Promise<Result<any>> {
        return await Api.post('/countercharge/buzzer/authority', params);
    }
}
